<div class="flex-center" *ngIf="label === 'Edit'" style="text-align: center;">
    <a (click)="onClick($event, 'Edit')" class="anchor-edit" id="edit" title="Edit">
    <span class="icon-edit icon-size-20 icon-edit icon-color"></span>
    </a>
</div>